var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390.38 317.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8CC7\u7522 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.88,96.35h-37.5L322.88,17a19.73,19.73,0,0,0-22-16.8L17,37.85a20,20,0,0,0-13,7.5,19.12,19.12,0,0,0-3.8,14.4l24,180.7a19.61,19.61,0,0,0,19.4,17,21.05,21.05,0,0,0,2.5-.2l18.8-2.5v43.3a19.46,19.46,0,0,0,19.5,19.5h286.5a19.46,19.46,0,0,0,19.5-19.5V115.85A19.46,19.46,0,0,0,370.88,96.35Zm-50.6,0h-50.9l50-6.6ZM13.08,58.05a6.43,6.43,0,0,1,1.3-4.8,6.2,6.2,0,0,1,4.3-2.5l283.9-37.6a6.6,6.6,0,0,1,7.4,5.6l2.6,19.4-297,39.3Zm51.8,183.7-20.5,2.7a6.45,6.45,0,0,1-7.3-5.6h0l-14.6-109.8,42.3-5.6v118.3Zm.8-131.5-44.9,5.9-3.4-25.8,296.9-39.3,2,14.9,1.4,10.8-147.4,19.6h-86A19.47,19.47,0,0,0,65.68,110.25Zm311.7,187.9a6.49,6.49,0,0,1-6.5,6.5H84.38a6.49,6.49,0,0,1-6.5-6.5V115.85a6.49,6.49,0,0,1,6.5-6.5h286.5a6.49,6.49,0,0,1,6.5,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.88,194.15a32.24,32.24,0,0,0,6.9-6.9,32.52,32.52,0,1,0,26.1-51.9,32.07,32.07,0,0,0-26,13.2,32.54,32.54,0,1,0-7,45.6Zm32.9-45.7a19.5,19.5,0,1,1-19.5,19.5A19.46,19.46,0,0,1,318.78,148.45Zm-52.1,0a19.5,19.5,0,1,1-19.5,19.5A19.46,19.46,0,0,1,266.68,148.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.88,
    y: 141.95,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.98,
    y: 141.95,
    width: 78.1,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.88,
    y: 167.95,
    width: 104.2,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.88,226.55H110.38a6.49,6.49,0,0,0-6.5,6.5v39.1a6.49,6.49,0,0,0,6.5,6.5h234.4a6.49,6.49,0,0,0,6.5-6.5v-39.1A6.34,6.34,0,0,0,344.88,226.55Zm-6.5,39.1H117v-26h221.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.333270b9a48cd02987c227cd2fe87395.svg";
export { ForwardRef as ReactComponent };